export default __webpack_public_path__ + "static/media/icon-half.00c0fbc2.svg";